import intl from "../services/intl";

const Currency = ({ value, round = false, ...props }) =>
  intl.formatCurrency(value, { round, ...props });

export default Currency;
